(function () {
  if (document.documentElement.hasAttribute('data-dark-forced')) return;
  'use strict';
  var KEY = 'canopy-color-mode';
  var root = document.documentElement;

  function saved() {
    try {
      var v = localStorage.getItem(KEY);
      return v === 'dark' ? 'dark' : 'light';
    } catch (e) { return 'light'; }
  }

  function apply(mode) {
    root.setAttribute('data-color-mode', mode);
    var dark = mode === 'dark';
    document.querySelectorAll('[data-color-mode-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(dark));
      b.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
    });
  }

  function init() {
    apply(saved());
    document.querySelectorAll('[data-color-mode-toggle]').forEach(function (b) {
      if (b.dataset.ready) return;
      b.dataset.ready = 'true';
      b.addEventListener('click', function () {
        var next = root.getAttribute('data-color-mode') === 'dark' ? 'light' : 'dark';
        apply(next);
        try { localStorage.setItem(KEY, next); } catch (e) {}
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();